import * as React from "react";
import { getServiceContext } from "~base/Services/ConsilioServiceContext";
import { getSettingsContext } from "~base/Settings/ConsilioSettingsContext";
import { getAvtalatIntlContext } from "~prad/Internationalization/AvtalatIntlContext";
import { getAvtalatValidationContext } from "~prad/Validation/AvtalatValidationContext";
import { getAvtalatNormalizerContext } from "~prad/Validation/AvtalatNormalizerContext";
import { guideServiceMock } from "~base/Services/Guide/IGuideService";
import { ContextWrapper } from "~base/ContextWrapper";
import AvtalatTheme from "~prad/Styling/AvtalatConsilioTheme";
import type { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";
import { defaultConfig } from "~base/Internationalization/ConfigurationInfo";
import * as textCodeService from "~base/Services/TextCodeService";
import { ErrorBoundary } from "~base/Components/Pages/Shared/ErrorBoundary";
import { MainRouter } from "./MainRoutes";

type MainProps = {
    children?: React.ReactNode;
};

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const MainApp: React.FunctionComponent<MainProps> = (props: MainProps) => {
    return (
        <ContextWrapper
            {...props}
            theme={AvtalatTheme as ConsilioBaseTheme}
            getServiceContext={getServiceContext}
            getSettingsContext={getSettingsContext}
            guide={guideServiceMock}
            useScreenSharing={false}
            loadUser={true}
            useServerContext={true}
            messages={textCodeService.textCodes()}
            getIntlContext={getAvtalatIntlContext}
            useUsersPreferredCulture={true}
            culture={"sv-SE"}
            currency={"SEK"}
            compatMode={true}
            enableLogoutListener={true}
            config={defaultConfig}
            getValidationContext={getAvtalatValidationContext}
            getNormalizerContext={getAvtalatNormalizerContext}
            intl={null}
            validation={null}
        >
            <ErrorBoundary catchJsErrors={true} catchPromiseErrors={true}>
                <MainRouter />
            </ErrorBoundary>
        </ContextWrapper>
    );
};

export default MainApp;
